import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from "react";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import LockResetIcon from '@mui/icons-material/LockReset';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {
    GridRowModes,
    DataGrid,
    GridToolbarContainer,
    GridActionsCellItem,
    GridRowEditStopReasons,
    GridEditInputCell
} from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';

import { Autocomplete, TextField } from "@mui/material";
import Helper from '../../Helper';

const Component = forwardRef((props, ref) => {

    const [rows, setRows] = React.useState([]);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const setError = (message, ismessage) => props.setError?.apply(this, [message, ismessage]);
    const [rowError, setRowError] = useState({});
    const [deleteRowId, setDeleteRowId] = useState(null);
    const [resetRowId, setResetRowId] = useState(null);
    const [loadingRow, setLoadingRow] = useState(null); // Track loading state

    const getbillitems = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getBillitem`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                setRows(data.result);
            } else {
                const data = await response.json();
                setError(data.message || 'Failed to fetch billitem');
            }
        } catch (err) {
            setError('An error occurred while fetching billitem.');
        }
    }
    useEffect(() => {

        getbillitems();


    }, []);
    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });

    };
    const validateRow = (newRow) => {
        if (!newRow.name) return "กรุณาระบุชื่อ";

        return null; // No errors
    };
    const handleProcessRowUpdate = async (newRow, oldRow) => {
        const error = validateRow(newRow);

        if (error) {
            setRowError((prev) => ({ ...prev, [newRow.id]: error })); // Store error
            throw new Error(error); // Prevent leaving edit mode
        }

        setRowError((prev) => ({ ...prev, [newRow.id]: undefined })); // Clear error

        var response = await saveData(newRow);
        newRow.rowid = response.rowid;
        setRows((prev) => prev.map((row) => (((row.id && newRow.id && row.id === newRow.id) || row.rowid == newRow.rowid) ? newRow : row)));
        return newRow;
    };
    const saveData = async (row) => {
        try {
            setLoadingRow(row.id); // Show loading
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/saveBillitem`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ billitem: row }),

            });
            const data = await response.json();
            if (response.ok) {
                setLoadingRow(null);

                setError("บันทึกข้อมูลเรียบร้อยแล้ว", true);
                return data.billitem;
            } else {
                setLoadingRow(null);
                throw new Error(data.message);
            }

        } catch (error) {
            setLoadingRow(null);
            throw new Error(error.message || "Failed to save data. Try again.");
        }
    };
    const handleDeleterowClick = (row) => () => {
        setDeleteRowId(row.rowid); // Open confirmation dialog
    };

    const handleDeleteClick = async () => {
        var deleterow = rows.find((row) => row.rowid == deleteRowId)
        setLoadingRow(deleterow.rowid);
        await deletebillitem(deleterow.rowid)
        setRows(rows.filter((row) => row.rowid != deleteRowId));
        setDeleteRowId(null);
    };

    const deletebillitem = async (rowid) => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/deleteBillitem/${rowid}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                }

            });
            const data = await response.json();
            if (response.ok) {
                setLoadingRow(null);

                setError("บันทึกข้อมูลเรียบร้อยแล้ว", true);
                return data;
            } else {
                setLoadingRow(null);

                throw new Error(data.message);
            }

        } catch (error) {
            setLoadingRow(null);

            throw new Error(error.message || "Failed to save data. Try again.");
        }
    };


    const handleCancelClick = (id) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rows.find((row) => row.id === id);
        if (editedRow && editedRow.isNew) {
            setRows(rows.filter((row) => row.id !== id));
        }
    };


    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const setItem = (event, newValue, params) => {
        if (!newValue) {
            params.api.setEditCellValue({ id: params.id, field: params.field, value: "user" })
            params.api.setEditCellValue({ id: params.id, field: "role_id", value: 2 })

            return;
        };
        params.api.setEditCellValue({ id: params.id, field: params.field, value: newValue.text })
        params.api.setEditCellValue({ id: params.id, field: "role_id", value: newValue.value })
    }


    const columns = [
        {
            sortable: true,
            field: 'rownum',
            headerName: '#',
            flex: 0,
            editable: false,
            width: 50,
            renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1

        },
        {
            field: 'billitemid',
            headerName: 'rowid',
            editable: true,
            hide: true,
        },
        {
            field: 'name',
            headerName: 'ชื่อรายการ',
            flex: 1,
            editable: true,

        },
        {
            field: 'isbillitem',
            headerName: 'เป็นรายการคิดเงิน',
            width: 180,
            editable: true,
            align: 'center',
            type: 'boolean',

        },
        {
            field: 'amount',
            type: 'number',
            headerName: 'ราคา',
            width: 200,

            editable: true,
            renderEditCell: (params) => (
                <GridEditInputCell
                    {...params}
                    inputProps={{
                        min: 0,
                    }}
                />
            ),
            valueFormatter: (value) => {
                return value || value ===0 ? new Intl.NumberFormat("en-US", {
                    style: "decimal",
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                }).format(value) : "";
            },

        }
        , {
            field: 'qty',
            headerName: 'จำนวน',
            type: 'number',

            width: 100,
            editable: true,

        },
        {
            field: 'vat',
            headerName: 'VAT%',
            type: 'number',
            width: 100,
            editable: true,

        },
        {
            field: 'wht',
            headerName: 'WHT%',
            type: 'number',
            width: 100,
            editable: true,

        },
        {
            field: 'canaddtoall',
            headerName: 'เพิ่มเข้ารายการทั้งหมดได้',
            width: 200,
            editable: true,
            type: 'boolean',

        },

        {
            field: 'isaddheader',
            headerName: 'เพิ่มข้อความหัวบิล',
            width: 180,
            editable: true,
            align: 'center',
            type: 'boolean',

        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'แก้ไข',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id, row }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<Tooltip title="บันทึก"><SaveIcon /></Tooltip>}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={handleSaveClick(id)}
                            disabled={loadingRow == id}
                        />,
                        <GridActionsCellItem
                            icon={<Tooltip title="ยกเลิก"><CancelIcon /></Tooltip>}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            disabled={loadingRow == id}
                            color="inherit"
                        />,
                    ];
                }

                return [
                    <GridActionsCellItem
                        icon={<Tooltip title="แก้ไข"><EditIcon /></Tooltip>}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        disabled={loadingRow != null && loadingRow == row.rowid}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<Tooltip title="ลบ"><DeleteIcon /></Tooltip>}
                        label="Delete"
                        hidden={row.isadmin}
                        onClick={handleDeleterowClick(row)}
                        disabled={loadingRow != null && loadingRow == row.rowid}
                        color="inherit"
                    />,
                ];
            },
        },


    ];

    function EditToolbar(props1) {
        const { setRows, setRowModesModel } = props1;

        const handleClick = () => {
            const id = uuidv4();
            setRows((oldRows) => [
                ...oldRows,
                { id, isNew: true },
            ]);
            setRowModesModel((oldModel) => ({
                ...oldModel,
                [id]: { mode: GridRowModes.Edit, fieldToFocus: 'username' },
            }));
        };

        return (
            <GridToolbarContainer>
                <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    เพิ่มรายการ
                </Button>
            </GridToolbarContainer>
        );
    }

    return (<>

        <DataGrid key={props.index}
            getRowId={(row) => row.id || uuidv4()}
            rows={rows}
            columns={columns}
            editMode="row"
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}

            slots={{ toolbar: EditToolbar }}
            slotProps={{
                toolbar: { setRows, setRowModesModel },
            }}


            columnVisibilityModel={{
                billitemid: false,

            }}

            processRowUpdate={handleProcessRowUpdate} // Prevents exit if invalid
            onProcessRowUpdateError={(error) => setError(error.message)} // Show error message
            hideFooter
            disableColumnMenu
        />

        <Dialog open={!!deleteRowId} onClose={() => setDeleteRowId(null)}>
            <DialogTitle>ยืนยันที่จะลบ</DialogTitle>
            <DialogContent>ต้องการที่จะลบรายการหรือไม่?</DialogContent>
            <DialogActions>
                <Button onClick={() => setDeleteRowId(null)}>ยกเลิก</Button>
                <Button onClick={handleDeleteClick} color="error">ลบ</Button>
            </DialogActions>
        </Dialog>


    </>

    );
});



export default Component;